import { RoutePath, type RoutePaths } from "@/lib/routes"

export const authRoutesPaths = {
    forgottenPassword: RoutePath.create("/mot-de-passe-oublie"),
    login: RoutePath.create("/connexion"),
    loginWithNextPage: RoutePath.create("/connexion?nextPage=:nextPage"),
    masquerade: RoutePath.create("/masquerade/:userId/:token"),
} as const satisfies RoutePaths
